import React, { useState, useEffect } from 'react';

// components:
import Marker from './Marker';

// examples:
import GoogleMap from './GoogleMap';
import SearchBox from './SearchBox';
import { Box } from '@mui/material';
import { decrypt } from '../../lib/encrypt';

/**
 * @params start: las coordenadas iniciales para el marcador {lat, lng}, tienen que se numeros
 * @params zoom: para aplicar un zoom por defecto, si no se define es 16
 * @params editable: true para poder hacer click y que cambie el marcador de lugar
 */
function Mapa({
    handleSelect = () => { },
    start = {
        lat: 20.6854551,
        lng: -103.3542671
    },
    zoom = 16,
    buscador = false,
    editable = false,
}) {
    const [mapApiLoaded, setMapApiLoaded] = useState(false);
    const [mapInstance, setMapInstance] = useState(null);
    const [mapApi, setMapApi] = useState(null);
    const [places, setPlaces] = useState([]);
    const [marker, setMarker] = useState(start);

    const apiHasLoaded = (map, maps) => {
        setMapApiLoaded(true);
        setMapInstance(map);
        setMapApi(maps);
    };

    const addPlace = (place) => {
        setPlaces(place);
        if (typeof place === 'Object') {
            handleSelect(place.geometry.location);
        } else {
            handleSelect({ lat: Number(place[0].geometry.location.lat()), lng: Number(place[0].geometry.location.lng()) });
        }
    };

    const onMapClick = ({ x, y, lat, lng, event }) => {
        const newCoordinates = { lat, lng };
        const newMarker = { lat, lng };
        setMarker(newMarker);
        handleSelect(newCoordinates);
    };

    const [mapKey, setMapKey] = useState('');
    const getMapKey = async () => {
        // obtener mapkey
        await fetch(`https://empresas-economiasocialysolidaria.com.mx/wp-json/api/v1/mapa`)
            .then(res => res.json())
            .then((respuesta) => {
                // desencriptar con key mapkeypassphrase
                let key = decrypt(respuesta.data, 'mapkeypassphrase');
                setMapKey(key);
            })

    }

    useEffect(() => {
        getMapKey();
    }, []);
    return (
        <Box sx={{ height: '500px', width: '100%', minHeight: '500px', borderRadius: 3, bgcolor: '#fefefe' }}>
            {mapApiLoaded && buscador && <SearchBox map={mapInstance} mapApi={mapApi} addplace={addPlace} />}

            {mapKey != '' &&
                <GoogleMap
                    defaultZoom={zoom}
                    defaultCenter={start}
                    bootstrapURLKeys={{
                        key: mapKey,
                        libraries: ['places', 'geometry'],
                    }}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({ map, maps }) => apiHasLoaded(map, maps)}
                    onClick={editable ? ({ x, y, lat, lng, event }) => onMapClick({ x, y, lat, lng, event }) : () => { }}
                >
                    {/* {places && places.length > 0
                    && places.map((place) => (
                        <Marker
                            key={place.id}
                            text={place.name}
                            lat={place.geometry.location.lat()}
                            lng={place.geometry.location.lng()}
                        />
                    ))} */}
                    {/* {(!places || places.length < 1) && marker && ( */}
                    {marker && (
                        <Marker
                            text="Marcador"
                            lat={marker.lat}
                            lng={marker.lng}
                        />
                    )}
                </GoogleMap>
            }
        </Box>
    );
}

export default Mapa;